export const ADDRESS_STRING_LENGTH = 4;
export const APP_VERSION = "v1.1";
export const LOCAL_SERVER_URL = "http://localhost:3001";
// export const SERVER_URL = 'http://localhost:3001'

export const SERVER_URL = (() => {
  const { REACT_APP_SERVER_URL, NODE_ENV } = process.env;

  if (NODE_ENV === 'production' && REACT_APP_SERVER_URL === undefined) {
    throw new Error('SERVER_URL is not specified')
  }

  // console.log("SERVER_URL", REACT_APP_SERVER_URL);
  if (REACT_APP_SERVER_URL === undefined) {
    if (NODE_ENV === 'production') return "https://prod-dhunter.ew.r.appspot.com";
    if (NODE_ENV === 'development') return "https://productiona.lm.r.appspot.com";
    else
      return LOCAL_SERVER_URL;

  }

  return REACT_APP_SERVER_URL;
})();

export const BOOOKSHOPPER_URL = (() => {
  const { REACT_APP_BOOKSHOPPER_URL, NODE_ENV } = process.env;

  if (NODE_ENV === 'production' && REACT_APP_BOOKSHOPPER_URL === undefined) {
    return "https://bookshopperapp.lm.r.appspot.com";
    // throw new Error('BOOKSHOPPER_URL is not specified')
  }

  // console.log("BOOKSHOPPER_URL", REACT_APP_BOOKSHOPPER_URL);
  if (REACT_APP_BOOKSHOPPER_URL === undefined) {
    // if (NODE_ENV === 'development')
    //   return "http://127.0.0.1";
    // else
    return "https://bookshopperapp.lm.r.appspot.com";

  }

  return REACT_APP_BOOKSHOPPER_URL;
})();

export const APP_FUNCTIONS_URL = (() => {
  return "https://europe-central2-prod-dhunter.cloudfunctions.net";
})();

export const BASE_32_CHAR_SET = "abcdefghijkmnpqrstuvwxyz23456789";

export const TOKENS_POLLING_INTERVAL = 5000;

export const PENDING_TRANSACTION_POLLING_INTERVAL = 200;

export const SEARCH_DEBOUNCE_TIME = 750;

export const AUDIOBOOK_PROTOCOL = "audiobook://";

export const LIBPANEL_DHC_ADDRESS = "camctnpf2qir8yp4u22kkj4s27cxc8jg"

export const TRANSACTION_STATES = {
  Pending: "PENDING",
  Accepted: "ACCEPTED",
  Rejected: "REJECTED",
  Unknown: "UNKNOWN",
};

export const USER_STATUS = {
  Active: 1,
  Deleted: -1,
  Inactive: 0,
};

export const QR_CODE_TYPES = {
  BINARY_NONCE: "n",
  TEXT_NONCE: "6",
  CREATE_TOKEN: "t",
  REQUEST_TRANSACTION: "r",
  LOGIN_USER: "l",
};

export const NOTIFICATION_TYPES = {
  EMPLOYEE_ADDED: "Dodano pracownika",
  USER_ADDED: "Dodano czytelnika",
  LIBRARY_ADDED: "Dodano bibliotekę",
  PUBLISHER_ADDED: "Dodano wydawcę",
  LIBRARY_EDITED: "Zaktualizowano bibliotekę",
  PUBLISHER_EDITED: "Zaktualizowano wydawcę",
  DATA_UPDATED: "Zaktualizowano dane",
};
